<template>
    <div class="stockDetail">
        <div class="wx_box">
            <div class="wx_main">
                <div class="top_btns">
                    <el-button  v-if="last!=null"  @click='jumpPage(last)'>上一农资</el-button>
                    <el-button v-if="next!=null" @click='jumpPage(next)'>下一农资</el-button>
                </div>
                <div class="meansName">{{material.name}}</div>
                <div class="select_year">
                    <span class="label">选择年份:</span>
                    <el-date-picker
                            v-model="year"
                            type="year"
                            format="yyyy"
                            size="mini"
                            placeholder="选择年" @change="changeYear">
                    </el-date-picker>
                </div>
                <h4 class="wx_title">入库明细</h4>
                <table class="my_table">
                    <thead>
                        <tr>
                            <th>入库时间</th>
                            <th>入库量 ({{material.units_name}})</th>
                            <th>入库总价 (元)</th>
                            <th>入库单价 (元/{{material.units_name}})</th>
                            <th>图片</th>
							<th>备注</th>
                            <th>技术员是否确定</th>
                            <th>操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in in_list" >
                            <td>{{item.created_at}}</td>
                            <td>{{item.change_number}}</td>
                            <td>{{item.total_price}}</td>
                            <td>{{item.unit_price}}</td>
                            <td>
                              <img :src="img" alt="" v-for="(img,key) in item.images" @click="jump(img)" :key="'list_img'+key">
                            </td>
							 <td>{{item.remark}}</td>
                            <td><span v-if="item.is_confirm==2">未确认</span><span v-if="item.is_confirm==1">已确认</span></td>
                            <td><el-button class="del_btn" type="danger" plain size="small"   @click="deleteData(item.id)" v-if="item.is_zhuan==2 && user_position_code<300">删除</el-button>
                                <el-button class="detail_btn" type="success" plain size="small" v-if="item.is_confirm==2 && user_position_code==150" @click="confirmData(item.id)">确认</el-button></td>
                        </tr>
                        
                        <tr>
                            <td>合计</td>
                            <td>{{in_number}}</td>
                            <td>{{in_total_price}}</td>
                        </tr>
                    </tbody>
                </table>
                <h4 class="wx_title">出库明细</h4>
                <table class="my_table">
                    <thead>
                    <tr>
                        <th>出库时间</th>
                        <th>出库量 ({{material.units_name}})</th>
                        <th>剩余库存 ({{material.units_name}})</th>
                        <th>出库原因</th>
                        <th>技术员是否确定</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody>
                       <tr v-for="(val,index) in out_list" >
                            <td>{{val.created_at}}</td>
                            <td>{{val.change_number}}</td>
                            <td>{{val.left_number}}</td>
                            <td>{{val.remark}}</td>
                              <td><span v-if="val.is_confirm==2">未确认</span><span v-if="val.is_confirm==1">已确认</span></td>
                            <td><el-button class="del_btn" type="danger" plain size="small"   @click="deleteData(val.id)" v-if="val.is_zhuan==2 && user_position_code<300">删除</el-button>
                                    <el-button class="detail_btn" type="success" plain size="small" v-if="val.is_confirm==2 && user_position_code==150" @click="confirmData(val.id)">确认</el-button></td>
                         
                        </tr>
                     
                        <tr>
                            <td>合计</td>
                            <td>{{out_number}}</td>
                        
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!--        删除弹窗-->
        <WxMessageBox :show="delShow" @save="delsave" @canse="delcanse">
            <div slot="content">
                <div class="word marTop">
                    <p>你是否确定删除此项，删除后，</p>
                    <p>将不可恢复！</p>
                </div>
            </div>
        </WxMessageBox>
    </div>
</template>

<script>
	import {getFarmStockRecord,stockRecordDelete,stockRecordConfirm} from '@/api/api'
    import WxMessageBox from '@/components/MessageBox';
    export default {
        name: "stockDetails",
        data(){
            return{
				user_position_code:'',
				farm_id:'',
				material_id:'',
                year:new Date().getFullYear().toString(),
                delShow:false,
				in_list:[],
				out_list:[],
				in_number:0,
				 next:'',
				 last:'',
				in_total_price:0,
				out_number:0,
				material:[],
            }
        },
		mounted() {
			this.farm_id = this.$route.params.id
			this.material_id=this.$route.params.material_id		
			this.get_farm_stock_record()
			
		},

        methods:{
			get_farm_stock_record(){
				 getFarmStockRecord(this.farm_id,this.material_id,this.year,1).then(resp=>{
					         this.in_list=resp.in_list
							 this.out_list=resp.out_list
							 this.user_position_code=resp.user_position_code
							 this.in_number=resp.in_number
							 this.in_total_price=resp.in_total_price
							  this.out_number=resp.out_number
							  this.material=resp.material
							  this.next=resp.next
							  this.last=resp.last
				 })
			},
			changeYear(val){
				this.year=val.getFullYear().toString()
				this.get_farm_stock_record();
			},
			jump(url) {
				window.open(url, "_blank")
			},
			jumpPage(id){
				this.$router.push("/park/stock/detail/"+this.farm_id+"/"+id)
				window.location.reload()
			},
			confirmData(id){
				 stockRecordConfirm(id).then(resp=>{
					
					 this.$message.success("确认成功")
					  this.get_farm_stock_record()
				 })
			},
			deleteData(id){
				this.delete_id=id
				 this.delShow = true
				
			},
            // 删除弹窗确定
            delsave(){
				stockRecordDelete(this.delete_id).then(resp=>{
									 this.$message.success("删除成功")
									  this.delShow = false
									   this.get_farm_stock_record()
				})
               
            },
            // 删除弹窗取消
            delcanse(){
                this.delShow = false
            },
        },
        components: {
            WxMessageBox
        }
    }
</script>

<style lang="less">
    .stockDetail{
        .wx_box{
            .wx_main{
                background:radial-gradient(rgba(19, 62, 173, 0.74),rgba(5, 18, 32, 0.47));
                background-size: cover;
                padding: 11px 35px 50px 24px;
                .top_btns{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .el-button{
                        border: 1px solid #2D99FF;
                        padding: 7px 22px;
                        font-size: 18px;
                        color: #2D99FF;
                        border-radius: 0;
                        background-color: transparent;
                    }
                }
                .meansName{
                    color: #fff;
                    font-size: 18px;
                    text-align: center;
                    position: absolute;
                    top: 20px;
                    left: 45%;
                }
                .select_year{
                    margin-top: 25px;
                    display: flex;
                    align-items: center;
                    .label{
                        width: 80px;
                        font-size: 16px;
                        color: #91AFBA;
                    }
                    .el-date-editor{
                        width: 125px;
                    }
                    .el-input__inner{
                        width: 125px;
                        text-align: center;
                        font-size: 16px;
                        background-color:transparent;
                        border: 1px solid #5C7E9F;
                        color: #91AFBA;
                    }
                }
                .wx_title{
                    font-size: 16px;
                    color: #fff;
                    padding: 26px 0 15px 0;
                }
                .my_table{
                    tr{
                        td{
                            img{
                                width: 66px;
                                height: 36px;
                            }
                        }
                        .red{
                            color: #FF3800;
                        }
                    }
                }
            }
        }
    }
</style>
